"use client"

import { useCallback } from "react"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { Button, DialogDescription, DialogTitle } from "@ui/shad"
import { CircleCheckBig } from "lucide-react"

import { CustomDialog } from "@/components/dialogs/custom-dialog"

export function UpgradeSuccessDialog() {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const open = searchParams.get("upgrade") === "success"

  const clearUpgradeStatus = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString())
    params.delete("upgrade")

    const queryString = params.toString()
    router.replace(queryString ? `${pathname}?${queryString}` : pathname, { scroll: false })
  }, [pathname, router, searchParams])

  return (
    <CustomDialog
      open={open}
      onOpenChange={(nextOpen) => !nextOpen && clearUpgradeStatus()}
      title={<>You&apos;re upgraded</>}
      titleProvided
      customClassName={"max-w-2xl overflow-hidden p-0"}
      contentProps={{}}
    >
      <div className="flex flex-col items-center px-8 py-10 text-center sm:px-14 sm:py-12">
        <div className="bg-green-background border-green-border flex size-16 items-center justify-center rounded-full border">
          <CircleCheckBig className="text-green-accent size-8" />
        </div>

        <DialogTitle className="mt-6 text-4xl font-semibold">You&apos;re upgraded</DialogTitle>
        <DialogDescription className="text-muted-foreground mt-3 max-w-lg text-base">
          Your payment went through, your account is active, and your workspace is ready.
        </DialogDescription>

        <Button className="mt-8" size="lg" onClick={clearUpgradeStatus}>
          Start using Slant
        </Button>
      </div>
    </CustomDialog>
  )
}
